import { _ as _extends } from '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import { forwardRef } from 'react';
import { useDisclosurePopupContext } from './context.js';
import { useMergeRefs } from '../../hooks/useMergeRefs.js';
import { jsx } from '@emotion/react';
import { Button } from '../Button/Button.js';
import '@indeed/ifl-css';
import '../../utils/transition.js';
import '../../utils/styled.js';
import '../../constants/index.js';
import '../../utils/createResponsive.js';
import '../../utils/transparentize.js';
import '../Button/context.js';
import '../IndeedThemeProvider/hooks/useColorMode.js';
import '../IndeedThemeProvider/hooks/useColorModeAttribute.js';
import '../../hooks/useIsomorphicLayoutEffect.js';
import '../Spinner/Spinner.js';
import '@indeed/ihl-use-id';
import '../IconWrapper/IconWrapper.js';

// Trigger
const DisclosurePopupTrigger = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  const {
    children,
    ...remainingProps
  } = props;
  const {
    contentId,
    contentRef,
    isOpen,
    portaledPopup,
    setAnchor,
    setOpen,
    triggerRef
  } = useDisclosurePopupContext();
  const mergedTriggerRef = useMergeRefs(forwardedRef, triggerRef, node => setAnchor(node));
  const handleOnBlur = event => {
    if (isOpen && !contentRef.current?.contains(event.relatedTarget)) {
      setOpen(false);
    }
  };
  const handleOnClick = event => {
    setOpen(!isOpen);
    remainingProps.onClick?.(event);
  };
  const handleOnKeyDown = event => {
    if (isOpen) {
      if (event.key === "Escape") {
        event.stopPropagation();
        setOpen(false);
      }
      if (event.key === "Tab" && !event.shiftKey && portaledPopup) {
        /**
         * If rendering in a portal, focus needs to be explicitly moved into
         * the popup. We cannot rely on the native DOM order for keyboard
         * navigation.
         */
        event.preventDefault();
        contentRef.current?.focus();
      }
    }
    remainingProps.onKeyDown?.(event);
  };
  return jsx(Button, _extends({
    ref: mergedTriggerRef
  }, remainingProps, {
    type: "button",
    "aria-controls": contentId,
    "aria-expanded": isOpen,
    onBlur: handleOnBlur,
    onClick: handleOnClick,
    onKeyDown: handleOnKeyDown
  }), children);
});
DisclosurePopupTrigger.displayName = "DisclosurePopupTrigger";

export { DisclosurePopupTrigger };
